import React, {Component} from "react";
import Chart from "react-apexcharts";
import PropTypes from "prop-types";
import { getDate } from "date-fns";

const PaceMakerBarChart = (props) => {
    const INITIAL: any = []
    const [chartData, setChartData] = React.useState(INITIAL);
    const [chartOptions, setChartOptions] = React.useState({});

    React.useEffect( () => {
        let operationList = [];
        // if(!!props.data) {
        //     gsdList = props.data.gsd;
        //     actualList = props.data.actual;
        //     operationList = props.data.operation
        // }
        setChartData(props.data.reportData.dataSets)

        setChartOptions({
            chart: {
                toolbar: {
                    show: true,
                    tools: {
                        download: true,
                        selection: false,
                        zoom: false,
                        zoomin: false,
                        zoomout: false,
                        pan: false,
                        reset: false,
                      }
                }

            },
            colors: ["#007bff","#ff9007","#adb5bd","#adb5bd","#adb5bd","#adb5bd","#adb5bd","#adb5bd","#adb5bd"
                ,"#adb5bd","#adb5bd","#adb5bd","#adb5bd","#adb5bd","#adb5bd","#adb5bd"
                ,"#adb5bd","#adb5bd","#adb5bd","#adb5bd","#adb5bd","#adb5bd","#adb5bd"
                ,"#adb5bd","#adb5bd","#adb5bd","#adb5bd","#adb5bd","#adb5bd","#adb5bd"
                ,"#adb5bd","#adb5bd","#adb5bd","#adb5bd","#adb5bd","#adb5bd","#adb5bd"
                ,"#adb5bd","#adb5bd","#adb5bd","#adb5bd","#adb5bd","#adb5bd","#adb5bd"
                ,"#adb5bd","#adb5bd","#adb5bd","#adb5bd","#adb5bd","#adb5bd","#adb5bd"
                ,"#adb5bd","#adb5bd","#adb5bd","#adb5bd","#adb5bd","#adb5bd","#adb5bd"
                // function ({ value, seriesIndex, dataPointIndex, w }) {
                //     if(dataPointIndex == 0) {
                //         return "#007bff";
                //     } else if(dataPointIndex == 1){
                //         return "#ff9007";
                //     } else {
                //         return "#adb5bd";
                //     }
                // }
            ],
            plotOptions: {
                bar: {
                    //borderRadius: 9,
                    columnWidth: '90%',
                }
            },
            tooltip: {
                enabled: true,
                custom: function({series, seriesIndex, dataPointIndex, w}) {
                    //return '<div class="arrow_box">' +
                    //'<span>' + series[seriesIndex][dataPointIndex] + '</span>' +
                    //'</div>'
                    const seriesItem = w.globals.initialSeries[seriesIndex];
                    const dataItem = seriesItem.data[dataPointIndex];
                    return '<div class="apexcharts-tooltip-series-group" style="order: 1; display: flex;">' +
                        '<span class="apexcharts-tooltip-marker" style="background-color: rgb(0, 123, 255);"></span>' +
                        '<div class="apexcharts-tooltip-text" style="font-family: Helvetica, Arial, sans-serif; font-size: 12px;">' +
                            '<div class="apexcharts-tooltip-y-group">'+
                                '<span class="apexcharts-tooltip-text-label">'+ seriesItem.name +': </span>'+
                                '<span class="apexcharts-tooltip-text-value">'+ dataItem.y +'</span>'+
                            '</div>'+ 
                            (dataItem.phaseMaker ? (
                            '<div class="apexcharts-tooltip-y-group">'+
                                '<span class="apexcharts-tooltip-text-label">Phase Maker: </span>'+
                                '<span class="apexcharts-tooltip-text-value">'+ dataItem.phaseMaker +'</span>'+
                            '</div>') : '') +                             
                        '</div>'+
                    '</div>'
                }
            },
            toolbar: {
                show: false
            },
            dataLabels: {
                enabled: true,
                offsetY: -20,
                style: {
                    fontSize: '12px',
                    colors: ["#304758"]
                }
            },
            legend: {
                show: true
            },
            fill: {
                opacity: 1,
                // colors: ['#05D20D','#f44336'],
            },
            stroke: {
                show: true,
                width: 4,
                colors: ['transparent']
            },
            xaxis: {
                categories: props.data.reportData.categories,
                labels: {
                    trim: true,
                    minHeight: 70,
                    maxHeight: 70,
                    style: {
                        fontSize: '12px'
                    }
                },
                title: {
                    text: 'Factory ' + props.data.reportData.factory + ' - Pitch time vs Pace maker CT behavior- ' 
                    + (new Date()).toLocaleString('en-UK', { year: 'numeric', month: 'long', day: 'numeric' })
                }

            },
            yaxis: {
                title: {
                    text: 'Time (sec)'
                },                
                decimalsInFloat: 0
            }
        })
    }, [props])

    return(
        <Chart options={chartOptions} series={chartData} type='bar' width={props.width} height={props.height} />
    )
}
PaceMakerBarChart.propTypes = {
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    data: PropTypes.object.isRequired,
}

export default PaceMakerBarChart;
